module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-MediumItalic.be2d9ae8.ttf";